import React from 'react';
import PropTypes from 'prop-types';

export default function PaginationResults({
  totalCount,
  firstIndex,
  lastIndex,
  queryType,
}) {
  return (
    <p className="pagination-results">
      {firstIndex} - {lastIndex} of {totalCount} <span>{queryType}</span>
    </p>
  );
}

PaginationResults.propTypes = {
  totalCount: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  firstIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  lastIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  queryType: PropTypes.oneOf(['properties', 'listings', 'events']).isRequired,
};
